var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgRankingNum10 = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 42 62"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rankingNum10_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.652 1.452A2.237 2.237 0 0 1 5.66 1.2h6.72c.56 0 .84.28.84.84v57.12c0 .56-.28.84-.84.84H5.996c-.56 0-.84-.28-.84-.84V10.02c0-.112-.056-.196-.168-.252-.056-.112-.112-.14-.168-.084l-3.476.932-.336.084c-.336 0-.56-.252-.672-.756L0 5.24c0-.504.196-.84.588-1.008l4.064-2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#rankingNum10_svg__b)",
    fillOpacity: 0.2,
    d: "M4.652 1.452A2.237 2.237 0 0 1 5.66 1.2h6.72c.56 0 .84.28.84.84v57.12c0 .56-.28.84-.84.84H5.996c-.56 0-.84-.28-.84-.84V10.02c0-.112-.056-.196-.168-.252-.056-.112-.112-.14-.168-.084l-3.476.932-.336.084c-.336 0-.56-.252-.672-.756L0 5.24c0-.504.196-.84.588-1.008l4.064-2.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M27.036 60.84c-4.536 0-8.176-1.428-10.92-4.284C13.372 53.7 12 49.892 12 45.132V16.068c0-4.76 1.372-8.568 4.116-11.424C18.86 1.788 22.5.36 27.036.36s8.176 1.428 10.92 4.284c2.8 2.856 4.2 6.664 4.2 11.424v29.064c0 4.76-1.4 8.568-4.2 11.424-2.744 2.856-6.384 4.284-10.92 4.284Zm0-6.972c2.128 0 3.836-.756 5.124-2.268 1.288-1.512 1.932-3.5 1.932-5.964V15.564c0-2.464-.644-4.452-1.932-5.964-1.288-1.512-2.996-2.268-5.124-2.268-2.072 0-3.752.756-5.04 2.268-1.288 1.512-1.932 3.5-1.932 5.964v30.072c0 2.464.644 4.452 1.932 5.964 1.288 1.512 2.968 2.268 5.04 2.268Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "rankingNum10_svg__b",
    x1: -4.999,
    x2: 13.002,
    y1: 60,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "rankingNum10_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h42v62H0z"
  })))));
});
SvgRankingNum10.displayName = "SvgRankingNum10";
export default SvgRankingNum10;